<template>
    <v-card v-if="loadCampaign" rounded="lg" class="rounded-lg pa-6 pt-2">
        <div class="headingIndicators colTemp mb-1">
            <h2 class="black--text mb-3">{{$t('selectedTemplate')}}</h2>
            <span class="btnResetTemp">
                <div class="d-flex flex-wrap justify-end">
                    <v-select style="width:200px;" v-if="campaignTemplateList && campaignTemplateList.length > 1" 
                        :items="campaignTemplateList"
                        v-model="templateSelected"
                        hide-details solo flat class="input-form flex-grow-0 mr-3" dense></v-select>
                    <v-select style="width:200px;" v-if="campaign && campaign.config && campaign.config.canal && campaign.config.canal == 'MAILING'" 
                        :items="[{text: $t('mailingTemplate'), value: false}, {text: $t('envelopeTemplate'), value: true}]"
                        v-model="switchEnvelope"
                        hide-details solo flat class="input-form flex-grow-0 mr-3" dense></v-select>
                    <v-btn small v-if="!campaign || !campaign.status || (campaign.status != 'PROGRAMMED' && campaign.status != 'COMPLETED' && campaign.status != 'CANCELED' && campaign.status != 'PREPARATION' && campaign.status != 'ON_GOING') && !this.fromPresta && $func.hasRight('retroplanning/update')" dark class="ma-1 bg-gradient" @click="openLib" depressed>{{ (!template || !template.hasOwnProperty('id') || !template.id) ? $t('selectTemplate') : $t('changeTemplate') }}</v-btn>
                    <v-btn small v-if="(!campaign || !campaign.status || (campaign.status != 'PROGRAMMED' && campaign.status != 'COMPLETED' && campaign.status != 'CANCELED' && campaign.status != 'PREPARATION' && campaign.status != 'ON_GOING')) && (template && (campaign.status == 'WORKFLOW' ||( template.hasOwnProperty('id')  && templateShown))) && !this.fromPresta && $func.hasRight('retroplanning/update')" depressed dark class="ma-1 bg-gradient" @click="editTemplate">{{ $t('edit') }}</v-btn>

                    <v-menu style="z-index: 150;" v-if="!switchEnvelope && (template.is_different_from_model || !template.model_source_id || campaign.sousType == 'campSMSconversational') && campaign.config.canal != 'MAILING' && !this.fromPresta && $func.hasRight('retroplanning/update')" offset-y>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn small dark class="ma-1 bg-gradient" v-bind="attrs" v-on="on" depressed>
                                <v-icon size="21"> $dots_l </v-icon>
                            </v-btn>
                        </template>
                        <v-list dense>
                            <v-list-item @click="callForm('confirm', formConvertUrl + template.id)">
                                <v-list-item-title>{{ $t('convertToModelTemplate') }}</v-list-item-title>
                            </v-list-item>
                            <v-list-item :disabled="!template.is_different_from_model || campaign.status !== 'DRAFT'" @click="openConfirmModal(template.id)">
                                <v-list-item-title>{{ $t('resetTemplate') }} {{ templateEnveloppe.is_different_from_model }}</v-list-item-title>
                            </v-list-item>
                            <v-list-item :disabled="campaign.status !== 'DRAFT'" v-if="campaign.sousType == 'campSMSconversational' && (!campaign.config.reminders || campaign.config.reminders.length < 2)" @click="callForm('addreminder', formAddReminderUrl + campaign.id)">
                                <v-list-item-title>{{ $t('addReminders') }}</v-list-item-title>
                            </v-list-item>
                            <v-list-item v-if="campaign.sousType == 'campSMSconversational' && campaign.config.reminders && campaign.config.reminders.length > 0 && templateSelected != 'base'" @click="openConfirmModal(templateSelected, 'deleteRemind')">
                                <v-list-item-title>{{ $t('deleteThisReminder') }}</v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>

                    <v-menu style="z-index: 150;" v-if="switchEnvelope && templateEnveloppe.id && (templateEnveloppe.is_different_from_model || !templateEnveloppe.model_source_id) && !this.fromPresta" offset-y>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn small dark class="ma-1 bg-gradient" v-bind="attrs" v-on="on" depressed>
                                <v-icon size="21"> $dots_l </v-icon>
                            </v-btn>
                        </template>
                        <v-list dense>
                            <v-list-item @click="callForm('confirm', formConvertUrl + templateEnveloppe.id)">
                                <v-list-item-title>{{ $t('convertToModelTemplate') }}</v-list-item-title>
                            </v-list-item>
                            <v-list-item :disabled="!templateEnveloppe.is_different_from_model || campaign.status !== 'DRAFT'" @click="openConfirmModal(templateEnveloppe.id)">
                                <v-list-item-title>{{ $t('resetTemplate') }} {{ templateEnveloppe.is_different_from_model }}</v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </div>
            </span>
        </div>
        <p :class="paramsShown && (typeof paramsShown.subject !== 'undefined') ? 'mb-0' : ''" v-if="paramsShown && ((typeof paramsShown.senderName !== 'undefined' && paramsShown.senderName !== '') || (typeof paramsShown.sender !== 'undefined' && paramsShown.sender !== ''))">
            <b>{{ $t('from') }} : </b> <span v-if="(typeof paramsShown.senderName !== 'undefined')">{{paramsShown.senderName}}</span> <span v-if="(typeof paramsShown.sender !== 'undefined')">&#60;{{paramsShown.sender}}&#62;</span>
        </p>
        <p v-if="paramsShown && (typeof paramsShown.subject !== 'undefined')">
            <b>{{ $t('subject') }} : </b> {{paramsShown.subject}}
        </p>
        <p v-if="templateShown && (typeof templateShown.link !== 'undefined')">
            <b>{{ $t('link') }} : </b> {{templateShown.link}}
        </p>
        <!-- EMAIL -->
         <v-alert color="warning" border="left" text dense v-if="opeVarInCampignWithoutOperation">
            <v-row align="center">
                <v-col class="grow">
                    {{ $t("operationVarInCampaignWithoutOperation") }}
                </v-col>
            </v-row>
         </v-alert>
        <v-alert color="warning" border="left" text dense v-if="paramsShown && ['EMAIL'].includes(template.canal) && ((!paramsShown.hasOwnProperty('subject') || !paramsShown.subject) || (!paramsShown.hasOwnProperty('sender') || !paramsShown.sender) || (!paramsShown.hasOwnProperty('senderName') || !paramsShown.senderName || !landing2Setted))">
            <v-row align="center">
                <v-col class="grow">
                    {{ $t("paramsAreMissing") }} : 
                    <li v-if="!paramsShown.hasOwnProperty('subject') || !paramsShown.subject">{{ $t("subject") }}</li>
                    <li v-if="!paramsShown.hasOwnProperty('sender') || !paramsShown.sender">{{ $t("sender") }}</li>
                    <li v-if="!paramsShown.hasOwnProperty('senderName') || !paramsShown.senderName">{{ $t("senderName") }}</li>
                    <li v-if="!landing2Setted">{{ $t("nolandingSelected") }}</li>
                </v-col>
            </v-row>
        </v-alert>
        <!-- VMS -->
        <v-alert color="warning" border="left" text dense v-if="paramsShown && ['VMS'].includes(template.canal) && (!paramsShown.hasOwnProperty('type') || !paramsShown.type || !landing2Setted)">
            <v-row align="center">
                <v-col class="grow">
                    {{ $t("paramsAreMissing") }} : 
                    <li v-if="!paramsShown.hasOwnProperty('type') || !paramsShown.type">{{ $t("type") }}</li>
                    <li v-if="!landing2Setted">{{ $t("nolandingSelected") }}</li>
                </v-col>
            </v-row>
        </v-alert>
        <!-- MAILING -->
        <v-alert color="warning" border="left" class="mt-4" text dense v-if="campaign && campaign.type === 'CAMP_OUT_P' && campaign.sousType === 'campMAILINGout' && (!campaign.config.template_envelope)">
            <v-row align="center">
                <v-col class="grow">
                    {{ $t("templateIsMissing") }}
                </v-col>
            </v-row>
        </v-alert>
        <div v-if="campaignTemplateList && campaignTemplateList.length > 1">
            <vCustomLibraryPicker v-if="templateSelected == 'base'"  @selectModel="selectModel" :returnEmit="true" :key="keyPicker" :model="{'operation_id': $route.params.operation_id, 'template' :{'id': template.id, 'name':template.name, 'image':null, 'template': templateShown}}" :fieldName="'template'" :field="{libType: campaign.config.canal, inCampaign: true, campaign: campaign}" @refreshAllTemplates="refreshAllTemplates"/>            
            <div v-if="campaign.sousType == 'campSMSconversational' && campaign.config.reminders && campaign.config.reminders.length > 0">
                <span v-for="(remind, index) in campaign.config.reminders" :key="'reminder_'+remind.id">
                    <vCustomLibraryPicker v-if="templateSelected == remind.id"  @selectModel="selectModel" :returnEmit="true" :key="keyPicker" :model="{'operation_id': $route.params.operation_id, 'template' :{'id': remind.template.id, 'name':remind.template.name, 'image':null, 'template': (reminderTemplates[remind.id] ? (reminderTemplates[remind.id].hasOwnProperty('template_compiled') ? reminderTemplates[remind.id].template_compiled : reminderTemplates[remind.id].template) : {})}}" :fieldName="'template'" :field="{libType: 'SMS', libFilters : {'filters.type': 'CONVERSATIONAL'}, inCampaign: true, campaign: campaign}" @refreshAllTemplates="refreshAllTemplates"/>            
                </span>

            </div>
        </div>
        <div v-else>
            <div v-if="campaign && campaign.config && campaign.config.canal && campaign.config.canal == 'MAILING'">
                <vCustomLibraryPicker  @selectModel="selectModel" :returnEmit="true" :key="keyPicker" v-if="!switchEnvelope" :model="{'operation_id': $route.params.operation_id, 'template' :{'id': template.id, 'name':template.name, 'image':null, 'template': templateShown}}" :fieldName="'template'" :field="{libType: campaign.config.canal, inCampaign: true, campaign: campaign}" @refreshAllTemplates="refreshAllTemplates"/>
                <vCustomLibraryPicker  @selectModel="selectModelEnveloppe" :returnEmit="true" :key="'env_'+keyPicker" v-else :model="{'operation_id': $route.params.operation_id, 'template' :{'id': templateEnveloppe.id, 'name':templateEnveloppe.name, 'image':null, 'template': templateEnvShown}}" :fieldName="'template'" :field="{libType: 'ENVELOPE', inCampaign: true, campaign: campaign}" @refreshAllTemplates="refreshAllTemplates"/>
            </div>
            <div v-else-if="campaign && campaign.type && campaign.type =='CAMP_IN'">
                <vCustomLibraryPicker @selectModel="selectModel" :returnEmit="true" :key="keyPicker" :model="{'operation_id': $route.params.operation_id, 'template' :{'id': template.id, 'name':template.name, 'image':null, 'template': templateShown}}" :fieldName="'template'" :field="{libType: 'TEL', inCampaign: true, campaign: campaign}" @refreshAllTemplates="refreshAllTemplates"/>
            </div>
            <div v-else>
                <vCustomLibraryPicker @selectModel="selectModel" :returnEmit="true" :key="keyPicker" :model="{'operation_id': $route.params.operation_id, 'template' :{'id': template.id, 'name':template.name, 'image':null, 'template': templateShown}}" :fieldName="'template'" :field="{libType: campaign.config.canal, inCampaign: true, campaign: campaign}" @refreshAllTemplates="refreshAllTemplates" :fromPresta="fromPresta"/>
            </div>
        </div>

        <ConfirmDialogComponent ref="confirmDialog" />
        <FormDialogComponent v-if="form" ref="componentForm" :type="formType" :form="form" :action="'SET_DATA'" />
        <LibraryDialogComponent v-if="formLib" :form="formLib" :libType="campaign.config.canal" @cancel="formLib = null;" :libParams="$route.params.operation_id" @selectModel="selectModel" :pickerForm="true" :showLibraryDialog="showLibraryDialog" @hideLibraryDialog="showLibraryDialog = false;" :isFromLibraryPage="false" />
    </v-card>
</template>
<script>
import GenericDataService from '@/services/GenericDataService'
import vCustomLibraryPicker from '../../../components/forms/inputs/v-custom-library-picker.vue'
import ConfirmDialogComponent from "@/components/dialogs/ConfirmDialogComponent";
import FormDialogComponent from "@/components/dialogs/FormDialogComponent";
import getForm from '@/mixins/mixins'
import LibraryDialogComponent from '../../../components/dialogs/LibraryDialogComponent.vue';

export default {
    name: "CampaignTemplate",
    components: {vCustomLibraryPicker, ConfirmDialogComponent, FormDialogComponent, LibraryDialogComponent},
    props: ['campaign', 'fromPresta'],
    mixins:[getForm],
    data() {
        return {
            template:{},
            templateEnveloppe:{},
            loader:false,
            switchEnvelope: false,
            keyPicker:0,
            formConvertUrl: "/library/getFormBeforeConvert?id=",
            formAddReminderUrl: "/retroplanning/getForm?formName=addRemind&id=",
            formType: "",
            formUrl: "",
            form: null,
            formLib:null,
            showLibraryDialog:false,
            previewModel:false,
            openPreviewDialog: false,
            loadCampaign: false,
            templateSelected: "base",
            reminderTemplates: {},
            remindKey:0
        }
    },
    created() {
        // setTimeout(() => {
        //     this.refreshAllTemplates(false);
        // }, 700);
        this.refreshAllTemplates(false);
    },
    watch: {
        campaign(newVal){
            this.refreshAllTemplates(false);
        },
    },
    computed: {
        campaignTemplateList(){
            let list = [
                {
                    text:this.$t("baseTemplate"),
                    value:"base"
                }
            ]
            if(this.campaign && this.campaign.config && this.campaign.config.reminders && this.campaign.config.reminders.length > 0){
                this.campaign.config.reminders.forEach((element) => {
                    list.push({
                        text:this.$t("reminder") + " - " + element.id + " ("+element.timer+"h)",
                        value:element.id
                    })
                });
            }
            return list
        },
        opeVarInCampignWithoutOperation() {
            let hasOpeVar = false;
            if(this.template && this.template.variables && this.template.variables.keys){
                this.template.variables.keys.forEach(element => {
                    if(element.includes('operation'))
                        hasOpeVar = true;
                });
            }

            return (this.campaign && !this.campaign.operation_id && hasOpeVar);
        },
        templateShown: function() {
            if(this.template && this.template.template) {
                if(this.template.template_compiled)
                    return this.template.template_compiled;
                else
                    return this.template.template;
            }
            
            return false;
        },
        templateEnvShown: function(){
            if(this.templateEnveloppe && this.templateEnveloppe.template) {
                if(this.showCompiledTemplate && this.templateEnveloppe.template_compiled)
                    return this.templateEnveloppe.template_compiled;
                else
                    return this.templateEnveloppe.template;
            }
            
            return false;
        },
        paramsShown: function() {
            if(this.template && this.template.params) {
                if(this.template.params_compiled)
                    return this.template.params_compiled;
                else
                    return this.template.params;
            }
            
            return false;
        },
        landing2Setted: function() {
            if(this.template && this.template.variables){
                for (const varName in this.template.variables.values) {
                    if (Object.prototype.hasOwnProperty.call(this.template.variables.values, varName)) {
                        const element = this.template.variables.values[varName];
                        if(varName.includes('landing_pagev2')){
                            if(!element.value)
                                return false;
                        }
                    }
                }
            }
            return true;
        }
    },
    methods: {
        selectModel(model){
            let payload = {
                "id": this.campaign.id,
                "config": this.campaign.config
            }
            if(this.campaign.config.canal == 'MAILING' && this.switchEnvelope)
                payload['config.template_envelope'] = model
            else
                payload['config.template'] = model

            if(this.campaign.operation_id)
                payload.operation_id = this.campaign.operation_id.id ? this.campaign.operation_id.id : this.campaign.operation_id

            if(this.campaign.entity_id)
                payload.entity_id = this.campaign.entity_id.id ? this.campaign.entity_id.id : this.campaign.entity_id

            let url = '/retroplanning/set?id='+this.campaign.id
            if(this.campaign.sousType == 'campSMSconversational' && this.templateSelected != 'base'){
                url = '/retroplanning/' + this.campaign.id + '/changeReminderTemplate?remind_id=' + this.templateSelected
            }
            GenericDataService.postData(url, payload).then((response) => {
                this.$store.commit("campaign/setCampaignData", response.data.data);
                this.refreshAllTemplates();
            })
        },
        selectModelEnveloppe(model){
            let payload = {
                "id": this.campaign.id,
                "config": this.campaign.config,
                "config.template_envelope" : model
            }

            if(this.campaign.operation_id)
                payload.operation_id = this.campaign.operation_id.id ? this.campaign.operation_id.id : this.campaign.operation_id

            if(this.campaign.entity_id)
                payload.entity_id = this.campaign.entity_id.id ? this.campaign.entity_id.id : this.campaign.entity_id

            GenericDataService.postData('/retroplanning/set?id='+this.campaign.id, payload).then((response) => {
                this.$store.commit("campaign/setCampaignData", response.data.data);
                this.refreshAllTemplates();
            })
        },
        changeSwitch($evt){
            if($evt)
                this.refreshTemplateEnveloppe()
            else
                this.refreshTemplate()

            this.keyPicker++
            this.$forceUpdate()
        },
        resizeIframe(id) {
            var iframe = document.getElementById(id);
            iframe.style.width = "100%";
            iframe.style.height = iframe.contentWindow.document.body.scrollHeight + 'px';
        },
        refreshAllTemplates(loadActions = true) {
            if(loadActions && !this.fromPresta) {
                GenericDataService.postData("/retroplanning/get?id=" + this.$route.params.id).then((response) => {
                    this.$store.commit("campaign/setCampaignData", response.data.data);
                    setTimeout(() => {
                        this.refreshTemplate();
                        this.refreshTemplateEnveloppe();
                        if(this.campaign.sousType == 'campSMSconversational' && this.campaign.config.reminders && this.campaign.config.reminders.length > 0){
                            this.refreshRemindersTemplate();
                        }
                    }, 1000);
                });
            } else {
                this.refreshTemplate();
                this.refreshTemplateEnveloppe();
                if(this.campaign.sousType == 'campSMSconversational' && this.campaign.config.reminders && this.campaign.config.reminders.length > 0){
                    this.refreshRemindersTemplate();
                }
            }
        },
        refreshRemindersTemplate(){
            let id = null;
            this.loader = true;
            this.reminderTemplates ={};
            if(this.campaign.config && this.campaign.config.reminders && this.campaign.config.reminders.length > 0) {
                this.campaign.config.reminders.forEach((element) => {
                    id = element.template.id ? element.template.id : element.template;

                    let url = '/retroplanning/' + this.campaign.id + '/getCompiledTemplate?id=' + id;
                    if(this.fromPresta)
                        url = '/mission/getCompiledTemplate?id=' + this.campaign.id + '&template_id=' + id;

                    GenericDataService.getDataThrowError(url).then((response) => {
                        if(response.data.data){
                            this.reminderTemplates[element.id] = response.data.data;
                            this.keyPicker++
                            this.loader = false;
                        }
                    });
                });
                
            } else {
                this.reminderTemplates ={};
                this.loader = false;
                this.loadCampaign = true;
            }
        },
        
        refreshTemplate() {
            let id = null;
            this.loader = true;
            if(this.campaign.config && this.campaign.config.template) {
                id = this.campaign.config.template.id ? this.campaign.config.template.id : this.campaign.config.template;

                let url = '/retroplanning/' + this.campaign.id + '/getCompiledTemplate?id=' + id;
                if(this.fromPresta)
                    url = '/mission/getCompiledTemplate?id=' + this.campaign.id + '&template_id=' + id;

                GenericDataService.getDataThrowError(url).then((response) => {
                    if(response.data.data){
                        this.template = response.data.data;
                        this.loader = false;
                        this.loadCampaign = true;
                    }
                });
            } else {
                this.template = {};
                this.loader = false;
                this.loadCampaign = true;

            }
        },
        refreshTemplateEnveloppe(){
            let id = null;
            this.loader = true;
            if(this.campaign.config && this.campaign.config.template_envelope) {
                id = this.campaign.config.template_envelope.id ? this.campaign.config.template_envelope.id : this.campaign.config.template_envelope;
                GenericDataService.getDataThrowError('/retroplanning/' + this.campaign.id + '/getCompiledTemplate?id=' + id).then((response) => {
                    if(response.data.data){
                        this.templateEnveloppe = response.data.data;
                        this.loader = false;
                    }
                });
            } else {
                this.templateEnveloppe = {};
                this.loader = false;
            }
        },
        async openConfirmModal(templateId, type = 'reset') {
            if(type == "reset"){
                if (await this.$refs.confirmDialog.open(this.$t("confirmResetTemplate"), this.$t("confirmResetTemplateMessage"))) {
                    GenericDataService.postData("/template/" + templateId + "/resetTemplate").then((response) => {
                        this.$store.dispatch('ADD_SNACK', { message : this.$t('successActionConfirmed') }).then((e) => { this.$store.dispatch("REMOVE_SNACK") });
                        this.refreshTemplate();
                        this.refreshTemplateEnveloppe();
                    });
                }
            } else if (type == 'deleteRemind'){
                if (await this.$refs.confirmDialog.open(this.$t("confirmDeleteReminder"), this.$t("confirmDeleteReminderMessage"))) {
                    let url = "/retroplanning/" + this.campaign.id + "/deleteReminder?remind_id=" + templateId;
                    GenericDataService.getDataThrowError(url).then((response) => {
                        this.templateSelected = "base";
                        this.refreshAllTemplates();
                    });
                }
            }
            
        },
        callForm(formType, formUrl) {
            this.formType = formType;
            this.formUrl = formUrl;
            this.getForm(formUrl);
        },
        customRefresh() {
            this.refreshAllTemplates();
            // this.refreshTemplate();
            // this.refreshTemplateEnveloppe();
        },
        openLib(){
            let url
            if (this.switchEnvelope) {
                url = '/library/getFilters?libType=' + 'ENVELOPE';
            }
            else {
                url = '/library/getFilters?libType=' + this.campaign.config.canal;
            }

            if(this.$route.params.operation_id)
                url += '&params[operation_id]=' + this.$route.params.operation_id;

            if(this.campaign.sousType === "campSMSconversational")
                url += '&filters[filters.type]=' + encodeURIComponent(JSON.stringify(["CONVERSATIONAL"]));

            GenericDataService.getData(url).then((response) => {
                this.formLib = response.data.data;
                this.showLibraryDialog = true
            });
        },
        editTemplate() {
            if(this.switchEnvelope) {
                this.getForm('/library/getForm?formName=ENVELOPE&id=' + this.templateEnveloppe.id + '&step=["conception"]'+(this.campaign && this.campaign.id ? '&postdata[retroplanning_id]='+this.campaign.id : ''));
            } else {
                if(this.templateSelected != 'base'){
                    let templateId = this.campaign.config.reminders.find(element => element.id == this.templateSelected).template.id;
                    this.getForm('/library/getForm?formName=' + this.campaign.config.canal + '&id=' + templateId + '&step=["conception"]'+(this.campaign && this.campaign.id ? '&duplicate=true&postdata[remind_id]='+this.templateSelected+'&postdata[retroplanning_id]='+this.campaign.id : ''));
                } else
                 this.getForm('/library/getForm?formName=' + this.campaign.config.canal + '&id=' + this.template.id + '&step=["conception"]'+(this.campaign && this.campaign.id ? '&postdata[retroplanning_id]='+this.campaign.id : ''));
            }
        }
    },
}
</script>

<style lang="scss">
    .colTemp {
        position:relative;
    }
    .btnResetTemp {
        position: absolute;
        z-index: 5;
        top: 10px;
        right: 0px;
        width: 60%;
    }
</style>